
/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */

require('./spark/spark-bootstrap');
require('./filters');
require('./app/bootstrap');

import 'babel-polyfill'; // IE11 support
import Element from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import Waves from 'vue-directive-waves';
import VueTruncate from 'vue-truncate';
 
window.Vue.use(Waves);
window.Vue.use(Element, { locale });
window.Vue.use(VueTruncate);

let OffCanvas = require('./app/mixins/off-canvas');
let Messages = require('./app/mixins/messages');


//register new fields for gifting functionality
Spark.forms.register = {
	is_gift:'',
	gift_sender_email: '',
	gift_sender_name: '',
	gift_sendout_date: '',
	temp_pwd: ''
}

let app = new Vue({
    mixins: [require('./spark/spark'), OffCanvas, Messages],

	mounted() {
		if(this.isIE()) {
			$('body').on('click', 'label img', function() {
				$(this).parent().click();
			});
		}
	},
	
	data() {
    	return {
    		tab: 'lesson'
		}
	},

    methods: {
	    // override support request message to remove sweet alert dependency
		showSupportRequestSuccessMessage() {
			this.showMessage('We have received your message and will respond soon!');
		},

		getNotifications() {
			// disable notifications for now...
		},

		isIE() {
			return (navigator.userAgent.indexOf('MSIE')!==-1
				|| navigator.appVersion.indexOf('Trident/') > 0);
		},
		
		toggleFavorites() {
			this.$root.$emit('toggle-favorites')
		}
	}
}).$mount('#spark-app');

